export default (width, desktopWidth, tabletWidth, mobileWidth) => ({
    width: width,
    desktopWidth: desktopWidth,
    tabletWidth: tabletWidth,
    mobileWidth: mobileWidth,  

    init() {
        this.width = window.innerWidth;

        window.addEventListener('resize', () => {
            this.width = window.innerWidth
        });

        this.$watch('width', value => value == 0 ? this.width = window.innerWidth : null);
    },
    isDesktop() {
        return this.width >= this.desktopWidth
    },
    isTablet() {
        return this.width <= this.desktopWidth && this.width >= this.tabletWidth
    },
    isMobile() {
        return this.width < this.tabletWidth;
    },
})
